onComplete(function() {
	var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;
	var ROCKET_WIDTH = 80;

	var launchers = document.querySelectorAll('.seal-launcher');
	for (var i = 0; i < launchers.length; i++) {
		(function(launcher) {
			var rocket = launcher.querySelector('.seal-rocket');
			var pool = launcher.closest('.seal-pool');

			function cleanupRocket() {
				rocket.classList.remove('is-launching');
				rocket.style.position = '';
				rocket.style.top = '';
				rocket.style.left = '';
				rocket.style.margin = '';
				launcher.appendChild(rocket);
			}

			function revealSeal() {
				launcher.classList.remove('is-launching');
			}

			function reset() {
				cleanupRocket();
				setTimeout(revealSeal, 2000);
			}

			launcher.addEventListener('click', function() {
				if (launcher.classList.contains('is-launching')) {
					return;
				}
				launcher.classList.add('is-launching');

				var launcherRect = launcher.getBoundingClientRect();
				var poolRect = pool ? pool.getBoundingClientRect() : launcherRect;

				rocket.style.position = 'fixed';
				rocket.style.margin = '0';
				rocket.style.left = (launcherRect.left + launcherRect.width / 2 - ROCKET_WIDTH / 2) + 'px';
				rocket.style.top = poolRect.bottom + 'px';
				document.body.appendChild(rocket);

				// Laat de browser de verplaatsing eerst een frame laten verwerken,
				// anders hapert het eerste stukje van de animatie.
				requestAnimationFrame(function() {
					requestAnimationFrame(function() {
						rocket.classList.add('is-launching');

						if (prefersReducedMotion) {
							setTimeout(reset, 1200);
						}
					});
				});
			});

			rocket.addEventListener('animationend', function(event) {
				if (event.animationName === 'seal-rocket-launch') {
					reset();
				}
			});
		})(launchers[i]);
	}
});
